import {POST} from "@/services/gateway";

const listUsers = ({pagination, search, filter}) => {
  return POST('dropbox/user/list', {pagination, search, filter});
}

export {
  listUsers,
}
